// extracted by mini-css-extract-plugin
module.exports = {"_subInfo":"Dokumentenuebersicht__subInfo__3b8_K","_checkbox":"Dokumentenuebersicht__checkbox__1I9Ng"};